import { Middleware, MiddlewareAPI } from 'redux';
import * as logger from 'logger';
import { getDatabase } from 'database';
import * as itemService from 'services/item-service';
import { LIST_OPERATION_ITEMS, SetOperationItemsAction, UPDATE_OPERATION_ITEM, 
  UpdateOperationItemAction, SetOperationItemAction } from './actions';
import { OperationItem } from 'types/operation-item';
import { currentOperationSelector } from 'components/menu/selectors';

const OperationGridMiddleware: Middleware = store => next => async action => {

  try {
    switch (action.type) {
      case LIST_OPERATION_ITEMS:
        await listOperationItems(store);
        break;

      case UPDATE_OPERATION_ITEM:
        await updateOperationItem(store, action);
        break;

      default:
        break;
    }
    next(JSON.parse(JSON.stringify(action)));
  }
  catch (e) {
    const error = e as Error;
    logger.error(error, 'OperationGridMiddleware');
  }
};

async function listOperationItems(store: MiddlewareAPI): Promise<void> {
  try {
    // list pending and completed rows
    const db = await getDatabase();
    const pendingRows: OperationItem[] = await db.readAll(db.config.indexes.Pending);
    const completedRows: OperationItem[] = await db.readAll(db.config.indexes.Complete);
    const nmvsActionType = currentOperationSelector(store.getState()).nmvsOperation;
    
    store.dispatch(new SetOperationItemsAction(
      pendingRows,
      completedRows,
      nmvsActionType));
  }
  catch (error) {
    logger.error(error, 'OperationGridMiddleware.listRows');
  }
}

async function updateOperationItem(store: MiddlewareAPI, action: UpdateOperationItemAction): Promise<void> {
  try {
    let operationItem = await itemService.getOperationItem(action.clientTransactionId);
    store.dispatch(new SetOperationItemAction(action.clientTransactionId, operationItem));
  }
  catch (error) {
    logger.error(error, 'OperationGridMiddleware.updateOperationItem');
  }
}

export default OperationGridMiddleware;


// WEBPACK FOOTER //
// ./src/components/operation-grid/middleware.ts